import allowedDocumentMimeTypes from 'constants/allowedDocumentMimeTypes';
import { fileTypeFromBuffer } from 'file-type';

export const allowedFileDocument = async (file: File) => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const fileTypeResult = await fileTypeFromBuffer(
      new Uint8Array(arrayBuffer)
    );

    if (
      !fileTypeResult ||
      !allowedDocumentMimeTypes.includes(fileTypeResult.mime)
    ) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};
